export default "__VITE_ASSET__JLIzJIST__"